import { NJProgress } from "@engie-group/fluid-design-system-react";
import type { ContextUsage } from "@/types";

/** Context-window usage gauge, rendered from the server-computed `contextUsage`. */
export function ContextUsageBar({ usage }: { usage: ContextUsage }) {
  return (
    <NJProgress
      value={usage.contextPercent}
      min={0}
      max={100}
      descriptionPosition="right"
      aria-label={`Context used: ${usage.contextPercent}%`}
    />
  );
}
